var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.607,
    height: 40.196,
    viewBox: "0 0 60.607 40.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22360",
    "data-name": "Caminho 22360",
    d: "M161.76,155.15v40.2h60.607v-40.2Zm57.9,37.492h-55.2V157.853h55.2Zm-3.354-17.394-24.245-14.961-24.245,14.961,24.245,14.961Zm-24.245-11.782,19.1,11.782-19.1,11.782-19.1-11.782Zm8.058,11.782a8.058,8.058,0,1,0-8.058,8.058A8.067,8.067,0,0,0,200.122,175.248Zm-13.411,0a5.353,5.353,0,1,1,5.353,5.353A5.359,5.359,0,0,1,186.711,175.248Z",
    transform: "translate(-161.76 -155.15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag01);
export default __webpack_public_path__ + "static/media/flag-01.b4147e763bd6f10bb616f30dde0e6537.svg";
export { ForwardRef as ReactComponent };